import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import axios from "axios"
import { IoClose } from "react-icons/io5"
import { FaCheck } from "react-icons/fa6";
import { ChangeValueAddUser, CleanValueAddUser } from "../Reducer/AddUserSlice"
import { setOpenChoiceComponentAR, setOpenMainMenu, setOpenModalAddUser, setOpenUserManagment } from "../Reducer/ModalSlice"
import { CityFromAddUserAdd, changeCityArrayAddedUser, changeCityArrayResponsibleUser } from "../Reducer/CitySlice"
import { addUsers } from "../Reducer/UserSlice"
import Select from "react-select";
import { roleId, role } from "../Components/Constants/app";

function AddUserModalWindow() {
    const AddedUser = useSelector(state => state.AddUserSlice.AddedUser)   
    const EditUser = useSelector(state => state.AddUserSlice.EditUser)  

    const CityArray = useSelector(state => state.CitySlice.CityArray)   

    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const OpenModal = useSelector(state => state.ModalSlice.OpenModal)

    const dispatch = useDispatch()

    const [OpenModalAddCityToUser, setOpenModalAddCityToUser] = useState(false)
    const [OpenFinalPart, setOpenFinalPart] = useState(false)
    const [CancelTouch, setCancelTouch] = useState(false)
    const [SelectedRole, setSelectedRole] = useState(null)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)

    useEffect(() => {
        setSelectedRole(role.find((item) => item.value === AddedUser.Role));
    }, [AddedUser])

    const RoleSelector = async (UserID) => {
        let Roles = ''
        await axios.get(Server + 'users-permissions/roles', {
            headers: {
              Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            Roles = response.data.roles
        })
        if(SelectedRole && SelectedRole.value) {
        let RoleChecker = Roles.find(el => el.id === SelectedRole.value)
        await axios.put(Server + 'users/' + UserID, {
            role: RoleChecker.id,
          }, {
            headers: {
              Authorization: 'Bearer ' + User.jwt,
            },
          });
        }
    }

    const AddResponsible = (FIO) => {
        CityArray.map((el) => {
        if(el.ResponsibleUser)
        {
            if(SelectedRole.value === roleId.manager || SelectedRole.value === roleId.director)
            {
                axios.put(Server +'cities/' + el.id, {
                    NameResponsibleUser: FIO
                }, {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                })

                axios.get(Server + 'cityadvancereports?_limit=-1', {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                    params:{
                        idCity: parseInt(el.id)
                    }})
                    .then((response) => {
                        response.data.map((el) => {
                            if(!el.ResponsiblesUsers.ManagerName)
                            {
                                axios.put(Server + 'cityadvancereports/' + el.id, {
                                    ResponsiblesUsers: {
                                        ManagerName: FIO,
                                        AccountantName: el.ResponsiblesUsers.AccountantName
                                    }
                                }, {
                                    headers: {
                                        Authorization: 'Bearer ' + User.jwt,
                                    }
                                })
                            }
                            return(el)
                        })
                    })
            }

            if(SelectedRole.value === roleId.accountant)
            {
                axios.put(Server +'cities/' + el.id, {
                    NameAccountantUser: FIO
                }, {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                })

                axios.get(Server + 'cityadvancereports?_limit=-1', {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                    params:{
                        idCity: parseInt(el.id)
                    }})
                    .then((response) => {
                        response.data.map((el) => {
                            if(!el.ResponsiblesUsers.AccountantName)
                            {
                                axios.put(Server + 'cityadvancereports/' + el.id, {
                                    ResponsiblesUsers: {
                                        ManagerName: el.ResponsiblesUsers.ManagerName,
                                        AccountantName: FIO
                                    }
                                }, {
                                    headers: {
                                        Authorization: 'Bearer ' + User.jwt,
                                    }
                                })
                            }
                            return(el)
                        })
                    })
            }
        }
        return(el)
        })
    }

    const handleClickSaveButton = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        setLoading(false)

        let ChekErr = false
        var ArrayAddCity = '0_0'
        await CityArray.map((el) => {
            if(el.AddedUser)
            {
                ArrayAddCity = ArrayAddCity + "_" + el.id
            }
            return(el)
        })
        if(!EditUser)
        {
        await axios.post(Server +'auth/local/register', {
            username: AddedUser.Email,
            email: AddedUser.Email,
            password: AddedUser.Password,
            FIO: AddedUser.FIO,
            idCity: ArrayAddCity
        }, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
            })
        .catch(() => {
            alert('Введенные данные не верны')
            ChekErr = true
        })
        .then(async (response) => {
            await RoleSelector(response.data.user.id)
            AddResponsible(AddedUser.FIO)
        })
        }
        else
        {
            await axios.put(Server +'users/' + AddedUser.id, {
                username: AddedUser.Email,
                email: AddedUser.Email,
                FIO: AddedUser.FIO,
                idCity: [roleId.admin, roleId.operatingDirector].includes(SelectedRole.value) ? 'All' : ArrayAddCity
            }, {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
            })
            .catch(() => {
                alert('Введенные данные не верны')
                ChekErr = true
            })
            .then(async () => {
                await RoleSelector(AddedUser.id)
                AddResponsible(AddedUser.FIO)
            })
        }

        if(!ChekErr)
        {
            setSuscessLoading(true)
            dispatch(CityFromAddUserAdd())
            if(EditUser)
            {
                await axios.get(Server + "users?_limit=-1", {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    }
                })
                .then((response) => {
                    var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                    dispatch(addUsers(addedUsersArray))
                });
            }               
            setLoading(true)

            setTimeout(() => {
                dispatch(CleanValueAddUser())
                dispatch(setOpenModalAddUser(false))
                if(EditUser)
                {
                    dispatch(setOpenUserManagment(true))
                }
                else
                {
                    if(OpenModal.SelectedSystem === 'FOT')
                        dispatch(setOpenMainMenu(true))

                    if(OpenModal.SelectedSystem === 'AR')
                        dispatch(setOpenChoiceComponentAR(true))
                } 
            }, 500)
        }
        else
        {
            setOpenFinalPart(false) 
            setOpenModalAddCityToUser(false)
        }
    }

    if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )

    if(!OpenModalAddCityToUser && !OpenFinalPart)
    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"

                    >
                        {!EditUser ? 'Добавление нового пользователя' : 'Изменине пользователя'} 
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() => {
                        dispatch(CityFromAddUserAdd())
                        dispatch(CleanValueAddUser())
                        dispatch(setOpenModalAddUser(false))

                        if(EditUser)
                        {
                            dispatch(setOpenUserManagment(true))
                        }
                        else
                        {
                            if(OpenModal.SelectedSystem === 'FOT')
                                dispatch(setOpenMainMenu(true))
    
                            if(OpenModal.SelectedSystem === 'AR')
                                dispatch(setOpenChoiceComponentAR(true))
                        } 
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(CityFromAddUserAdd())
                            dispatch(CleanValueAddUser())
                            dispatch(setOpenModalAddUser(false))
                            
                            if(EditUser)
                            {
                                dispatch(setOpenUserManagment(true))
                            }
                            else
                            {
                                if(OpenModal.SelectedSystem === 'FOT')
                                    dispatch(setOpenMainMenu(true))
        
                                if(OpenModal.SelectedSystem === 'AR')
                                    dispatch(setOpenChoiceComponentAR(true))
                            } 
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>

                <div
                className="ModalJustify"
                >
                    <div
                    className="AddStaffGapDiv"
                    >
                        <div
                        className="InputModalMainDiv"
                        >
                            <div
                            className="InputModalTextDiv"
                            >
                            {'ФИО: '} 
                            </div>
                            <input
                            className="InputModal UserAdd"
                            id='InputAddUserFIO'
                            value={AddedUser.FIO}
                            onClick={(() => {
                                document.getElementById('InputAddUserFIO').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    document.getElementById('InputAddUserFIO').classList.remove('Allert')
                                    document.getElementById('InputAddUserFIO').focus()
                                }
                            })}
                            onChange={((e) => {
                                dispatch(ChangeValueAddUser({Type: 'FIO', Value: String(e.target.value)}))
                            })}
                            /> 
                        </div>

                        <div
                        className="InputModalMainDiv"
                        >
                            <div
                            className="InputModalTextDiv"
                            >
                            {'Email: '} 
                            </div>
                            <input
                            className="InputModal UserAdd"
                            id='InputAddUserEmail'
                            value={AddedUser.Email}
                            onClick={(() => {
                                document.getElementById('InputAddUserEmail').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    document.getElementById('InputAddUserEmail').classList.remove('Allert')
                                    document.getElementById('InputAddUserEmail').focus()
                                }
                            })}
                            onChange={((e) => {
                                dispatch(ChangeValueAddUser({Type: 'Email', Value: String(e.target.value)}))
                            })}
                            /> 
                        </div>

                        {!EditUser && <div
                        className="InputModalMainDiv"
                        >
                            <div
                            className="InputModalTextDiv"
                            >
                            {'Пароль: '} 
                            </div>
                            <input
                            className="InputModal UserAdd"
                            id='InputAddUserPassword'
                            value={AddedUser.Password}
                            onClick={(() => {
                                document.getElementById('InputAddUserPassword').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    document.getElementById('InputAddUserPassword').classList.remove('Allert')
                                    document.getElementById('InputAddUserPassword').focus()
                                }
                            })}
                            onChange={((e) => {
                                dispatch(ChangeValueAddUser({Type: 'Password', Value: String(e.target.value)}))
                            })}
                            /> 
                        </div>}

                        <div
                        className="PostAddUserGlobalDiv"
                        >
                            <div
                            className="InputModalTextDiv"
                            >
                            {'Роль: '} 
                            </div>
                            <div style={{ width: '100%' }}>
                                <Select
                                    closeMenuOnSelect={true}                    
                                    options={role.filter((item) => !item.access || [item.access].includes(User.user.role.id))}
                                    onChange={((e) => setSelectedRole(e))}
                                    placeholder="Роль"
                                    noOptionsMessage={() => 'Нет ролей'}
                                    value={SelectedRole}
                                />
                            </div>                            
                        </div>
                    </div>
                    
                    <div
                    className="ModalButtonsDiv"
                    >
                        <button
                        className="ModalButton Cancle"
                        onClick={(() => {
                            dispatch(CleanValueAddUser())
                            dispatch(CityFromAddUserAdd())
                            dispatch(setOpenModalAddUser(false))   

                            if(EditUser)
                            {
                                dispatch(setOpenUserManagment(true))
                            }
                            else
                            {
                                if(OpenModal.SelectedSystem === 'FOT')
                                    dispatch(setOpenMainMenu(true))
        
                                if(OpenModal.SelectedSystem === 'AR')
                                    dispatch(setOpenChoiceComponentAR(true))
                            }                  
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                dispatch(CleanValueAddUser())
                                dispatch(CityFromAddUserAdd())
                                dispatch(setOpenModalAddUser(false))     
                                
                                if(EditUser)
                                {
                                    dispatch(setOpenUserManagment(true))
                                }       
                                else
                                {
                                    if(OpenModal.SelectedSystem === 'FOT')
                                        dispatch(setOpenMainMenu(true))
            
                                    if(OpenModal.SelectedSystem === 'AR')
                                        dispatch(setOpenChoiceComponentAR(true))
                                }
                            }                
                        })}
                        >
                            Отмена
                        </button>

                        <button
                        className="ModalButton Save"
                        onClick={(() => {
                            var ErorrCheck = 0
                            if(AddedUser.FIO === '')
                            {
                                ErorrCheck = ErorrCheck + 1
                                document.getElementById('InputAddUserFIO').classList.add('Allert')
                            }
                            if(AddedUser.Email === '')
                            {
                                ErorrCheck = ErorrCheck + 1
                                document.getElementById('InputAddUserEmail').classList.add('Allert')
                            }
                            if(AddedUser.Password === '' && !EditUser)
                            {
                                ErorrCheck = ErorrCheck + 1
                                document.getElementById('InputAddUserPassword').classList.add('Allert')
                            }
                            if(!SelectedRole || !SelectedRole.value)
                            {
                                ErorrCheck = ErorrCheck + 1
                                alert('Не выбрана роль')
                            }
                            if(ErorrCheck === 0)
                            {
                                if([roleId.admin, roleId.operatingDirector].includes(SelectedRole.value))
                                {
                                    setOpenFinalPart(true)
                                }
                                else
                                {
                                    setOpenModalAddCityToUser(true)
                                }
                                
                            }
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                var ErorrCheck = 0
                                if(AddedUser.FIO === '')
                                {
                                    ErorrCheck = ErorrCheck + 1
                                    document.getElementById('InputAddUserFIO').classList.add('Allert')
                                }
                                if(AddedUser.Email === '')
                                {
                                    ErorrCheck = ErorrCheck + 1
                                    document.getElementById('InputAddUserEmail').classList.add('Allert')
                                }
                                if(AddedUser.Password === '' && !EditUser)
                                {
                                    ErorrCheck = ErorrCheck + 1
                                    document.getElementById('InputAddUserPassword').classList.add('Allert')
                                }
                                if(!SelectedRole || !SelectedRole.value)
                                {
                                    ErorrCheck = ErorrCheck + 1
                                    alert('Не выбрана роль')
                                }
                                if(ErorrCheck === 0)
                                {
                                    if([roleId.admin, roleId.operatingDirector].includes(SelectedRole.value))
                                    {
                                        setOpenFinalPart(true)
                                    }
                                    else
                                    {
                                        setOpenModalAddCityToUser(true)
                                    }
                                    
                                }
                            }
                        })}
                        >
                            Далее
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

    if(OpenModalAddCityToUser && !OpenFinalPart)
    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Добавление нового пользователя
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() => {
                        dispatch(CleanValueAddUser())
                        dispatch(setOpenModalAddUser(false))
                        
                        if(EditUser)
                        {
                            dispatch(setOpenUserManagment(true))
                        }
                        else
                        {
                            if(OpenModal.SelectedSystem === 'FOT')
                                dispatch(setOpenMainMenu(true))
    
                            if(OpenModal.SelectedSystem === 'AR')
                                dispatch(setOpenChoiceComponentAR(true))
                        } 

                        dispatch(CityFromAddUserAdd())
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(CleanValueAddUser())
                            dispatch(setOpenModalAddUser(false))

                            if(EditUser)
                            {
                                dispatch(setOpenUserManagment(true))
                            }
                            else
                            {
                                if(OpenModal.SelectedSystem === 'FOT')
                                    dispatch(setOpenMainMenu(true))
        
                                if(OpenModal.SelectedSystem === 'AR')
                                    dispatch(setOpenChoiceComponentAR(true))
                            } 

                            dispatch(CityFromAddUserAdd())
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="AddUserCityMainDiv"
                >
                    <div
                    className="AddUserCityContain"
                    >
                        {CityArray.map((el) => 
                            <div
                            key={el.id}
                            className="AddUserOneCityMainContain"
                            >
                                <div
                                className="AddUserOneCityContain"
                                onClick={(() => {
                                    dispatch(changeCityArrayAddedUser(el.id))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        dispatch(changeCityArrayAddedUser(el.id))
                                })}
                                >
                                    <div
                                    className={el.AddedUser ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                    >
                                        <FaCheck className={el.AddedUser ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                    </div>
                                    <div>
                                        {el.City + ' ' + el.Adress}
                                    </div>                                
                                </div>
                                {el.AddedUser && (SelectedRole.value === roleId.manager || SelectedRole.value === roleId.director) &&          
                                    <div 
                                    className="AddUserOneCityContain BorderTop"
                                    onClick={((event) => {        
                                        event.stopPropagation()                                
                                        dispatch(changeCityArrayResponsibleUser(el.id))
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault()
                                        if(!CancelTouch)
                                        {
                                            event.stopPropagation()                                
                                            dispatch(changeCityArrayResponsibleUser(el.id))
                                        }
                                    })}
                                    >                                                       
                                        <div
                                        className={el.ResponsibleUser ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                        >
                                            <FaCheck className={el.ResponsibleUser ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                        </div>    
                                        <div>
                                            Назначить ответственным филиала
                                        </div>
                                    </div>                              
                                }
                                {el.AddedUser && SelectedRole.value === roleId.accountant &&
                                    <div 
                                    className="AddUserOneCityContain BorderTop"
                                    onClick={((event) => {
                                        event.stopPropagation()
                                        dispatch(changeCityArrayResponsibleUser(el.id))
                                    })}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={((event) => {
                                        event.preventDefault()
                                        if(!CancelTouch)
                                        {
                                            event.stopPropagation()                                
                                            dispatch(changeCityArrayResponsibleUser(el.id))
                                        }
                                    })}
                                    >                                                       
                                        <div
                                        className={el.ResponsibleUser ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                        >
                                            <FaCheck className={el.ResponsibleUser ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                        </div>    
                                        <div>
                                            Назначить бухгалтером филиала
                                        </div>
                                    </div>  
                                }
                            </div>
                        )}
                    </div>
                </div>

                <div
                className="ModalButtonsDiv"
                >
                    <button
                    className="ModalButton Cancle"
                    onClick={(() => {
                        setOpenModalAddCityToUser(false)                           
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            setOpenModalAddCityToUser(false)                           
                    })}
                    >
                        Назад
                    </button>

                    <button
                    className="ModalButton Save"
                    onClick={(async () => {
                        var CityCheck = 0
                        await CityArray.map((el) => {
                            if(el.AddedUser)
                            {
                                CityCheck = CityCheck + 1
                            }
                            return(el)
                        })
                        if(CityCheck > 0)
                            {
                                setOpenFinalPart(true)
                            }
                            else
                            {
                                alert('Филиалы не выбраны')
                            }
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            var CityCheck = 0
                            await CityArray.map((el) => {
                                if(el.AddedUser)
                                {
                                    CityCheck = CityCheck + 1
                                }
                                return(el)
                            })
                            if(CityCheck > 0)
                            {
                                setOpenFinalPart(true)
                            }
                            else
                            {
                                alert('Филиалы не выбраны')
                            }
                        }
                    })}
                    >
                        Далее
                    </button>
                </div>
            </div>
        </div>
    )

    if(OpenFinalPart)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="ModalMainDiv"
                >
                    <div
                    className="ModalInformationDiv"
                    >
                        <div
                        className="ModalInformationTextDiv"
                        >
                            Добавление нового пользователя
                        </div>
                        <div
                        className="CloseModalIconDiv"
                        onClick={(() => {
                            dispatch(CleanValueAddUser())
                            dispatch(setOpenModalAddUser(false))
                            
                            if(EditUser)
                            {
                                dispatch(setOpenUserManagment(true))
                            }
                            else
                            {
                                if(OpenModal.SelectedSystem === 'FOT')
                                    dispatch(setOpenMainMenu(true))
        
                                if(OpenModal.SelectedSystem === 'AR')
                                    dispatch(setOpenChoiceComponentAR(true))
                            } 

                            dispatch(CityFromAddUserAdd())
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                dispatch(CleanValueAddUser())
                                dispatch(setOpenModalAddUser(false))
                                
                                if(EditUser)
                                {
                                    dispatch(setOpenUserManagment(true))
                                }
                                else
                                {
                                    if(OpenModal.SelectedSystem === 'FOT')
                                        dispatch(setOpenMainMenu(true))
            
                                    if(OpenModal.SelectedSystem === 'AR')
                                        dispatch(setOpenChoiceComponentAR(true))
                                } 

                                dispatch(CityFromAddUserAdd())
                            }
                        })}
                        >
                            <IoClose
                            className="CloseModalIcon"
                            />
                        </div>
                    </div>
                    <div
                    className="ModalJustify"
                    >
                        <div
                        className="AddStaffGapDiv"
                        >
                            <div
                            className="AddedCityUser"
                            >
                                <div
                                className="AddedCityUserText"
                                >
                                    ФИО:
                                </div>
                                <div>
                                    {AddedUser.FIO}
                                </div>
                            </div>
                            
                            <div
                            className="AddedCityUser"
                            >
                                <div
                                className="AddedCityUserText"
                                >
                                    Email:
                                </div>
                                <div>
                                    {AddedUser.Email}
                                </div>
                            </div>

                            {!EditUser && 
                            <div
                            className="AddedCityUser"
                            >
                                <div
                                className="AddedCityUserText"
                                >
                                    Пароль:
                                </div>
                                <div>
                                    {AddedUser.Password}
                                </div>
                            </div>
                            }

                            
                            <div
                            className="AddedCityUser"
                            >
                                <div
                                className="AddedCityUserText"
                                >
                                    Права:
                                </div>
                                <div>
                                    {SelectedRole ? SelectedRole.label : ''}
                                </div>
                            </div>
                            
                            
                            
                            {[roleId.admin, roleId.operatingDirector].includes(SelectedRole.value) && 
                            <>
                                <div
                                className="InputModalMainDiv FinalPartAddUser"
                                >
                                    <div
                                    className="AddedCityUserText"
                                    >
                                    Филиалы:
                                    </div>             
                                </div>             
                                <div
                                className="AddedCityUser"
                                >
                                    {CityArray.map((el) => 
                                            el.AddedUser &&
                                            <div
                                            key={el.id}
                                            className="OneAddedCityUser"
                                            >
                                                {el.City + ' ' + el.Adress}
                                            </div>
                                        )} 
                                </div>     
                            </>          
                            }
                        </div>
                        
                    <div
                    className="ModalButtonsDiv"
                    >
                            <button
                            className="ModalButton Cancle"
                            onClick={(() => {
                                setOpenFinalPart(false)                           
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                    setOpenFinalPart(false)                           
                            })}
                            >
                                Назад
                            </button>
    
                            <button
                            className="ModalButton Save"
                            onClick={handleClickSaveButton}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={(event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                    handleClickSaveButton(event)
                            }}
                            >
                                Сохранить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
}

export default AddUserModalWindow;
